import { render, staticRenderFns } from "./word-usage-examples-filters.vue?vue&type=template&id=b2a85ee6&"
import script from "./word-usage-examples-filters.vue?vue&type=script&lang=js&"
export * from "./word-usage-examples-filters.vue?vue&type=script&lang=js&"
import style0 from "./word-usage-examples-filters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2a85ee6')) {
      api.createRecord('b2a85ee6', component.options)
    } else {
      api.reload('b2a85ee6', component.options)
    }
    module.hot.accept("./word-usage-examples-filters.vue?vue&type=template&id=b2a85ee6&", function () {
      api.rerender('b2a85ee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/word-usage-examples/word-usage-examples-filters.vue"
export default component.exports